import { FC, useState } from 'react';
import {
  useGetTeamShortcut,
  useUpdateTeamShortcut,
} from '@frx/frx-react-context';

import { GetCustomUrlResponse } from '@frx/frx-services';
import { UseDisclosureProps } from '@chakra-ui/react';
import { useEventId } from '../../../../hooks';
import { CustomUrlModal } from '../../../../components';

export type CustomTeamUrlProps = Required<
  Pick<UseDisclosureProps, 'isOpen' | 'onClose'>
>;

export const CustomTeamUrl: FC<CustomTeamUrlProps> = ({ isOpen, onClose }) => {
  const [page, setPage] = useState('create');
  const [errorMessage, setErrorMessage] = useState('');
  const FR_ID = useEventId();
  const { data } = useGetTeamShortcut({ fr_id: FR_ID });
  const {
    mutate: update,
    isLoading: isSavingUrl,
    isError,
  } = useUpdateTeamShortcut();

  const onSave = (url: string) => {
    update(
      { fr_id: FR_ID, text: url },
      {
        onSuccess: () => {
          setPage('confirm');
        },
        onError(err) {
          if (err.code === 2613) {
            setErrorMessage(
              'This custom URL already exists. Please choose another URL.'
            );
          } else {
            setErrorMessage('Sorry, we are unable to save the URL.');
          }
        },
      }
    );
  };

  return (
    <CustomUrlModal
      headingLabel="Create your custom team page URL"
      data={data as GetCustomUrlResponse}
      pageName={page}
      isSaving={isSavingUrl}
      onSave={(url: string) => {
        onSave(url);
      }}
      onStepClose={() => {
        setErrorMessage('');
        setPage('create');
        onClose();
      }}
      isOpen={isOpen}
      isError={isError}
      errorMessage={errorMessage}
    />
  );
};
